const mathJaxAssetRoot = `${process.env.PUBLIC_URL || ''}/assets/mathjax`;

export const mathJaxSource = `${mathJaxAssetRoot}/mml-chtml.js`;

export const mathJaxConfig = {
  chtml: {
    fontURL: `${mathJaxAssetRoot}/output/chtml/fonts/woff-v2`
  },
  options: {
    enableMenu: false
  },
  startup: {
    typeset: false
  }
};
